<template>
  <div class="reviewPage aboutView" style="padding-top:0px;padding-bottom:0px">
    <div v-if="isNullObject(articleMsg)">
      <mpSkeletonScreen></mpSkeletonScreen>
    </div>

    <div v-else>
      <mavon-editor
        :style="`min-height:${minHeight}px`"
        :subfield="false"
        defaultOpen="preview"
        :toolbarsFlag="false"
        :toolbars="markdownOption"
        :boxShadow="false"
        @change="change"
        v-model="articleMsg.articleContent"
      />
    </div>
  </div>
</template>

<script>
import mpSkeletonScreen from "@/components/mp-skeleton-screen/mp-skeleton-screen.vue";
export default {
  components: {
    mpSkeletonScreen
  },
  data() {
    return {
      markdownOption: {},
      articleMsg: {
        articleContent:
          "## <center>MPai公测时间延长公告</center>\n\n### 尊敬的用户您好:  \n#### MPai数据科学平台公测截止日期由8月25日延长至8月31日。<br/><br/><br/><br/><br/><br/>广州万灵数据科技有限公司\n\n2020年8月25日"
      },
      html: ""
    };
  },
  mounted() {
    if (this.$route.query.articleId !== undefined) {
      this.reviewPage(this.$route.query.articleId);
    } else {
      this.$router.replace("/notice");
    }
  },
  watch: {
    articleMsg(val) {
      console.log("sdgajhdg", val);
    }
  },
  computed: {
    minHeight: {
      get() {
        return this.$store.state.height;
      },
      set(height) {
        this.$store.dispatch("commitHeight", height);
      }
    }
  },
  methods: {
    change(value, render) {
      // render 为 markdown 解析后的结果[html]
      this.html = render;
    },
    isNullObject(articleMsg) {
      return JSON.stringify(articleMsg) === "{}";
    },
    reviewPage(articleId) {
      this.getArticleApi(articleId);
    },
    getArticleApi(articleId) {
      var that = this;
      this.$axios
        .getArticle(articleId)
        .then(res => {
          that.articleMsg = res.data.data;
        })
        .catch(() => {
          this.$router.replace("/notice");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../public/static/style/page.less";
</style>
